import { createAPI } from "../apisServer";

import BaseUrl from "../baseUrls";

import { decryptApiKey } from "../../util/crypt";

const banco = BaseUrl.dataBase;
const apiServer = createAPI("multiTenant");

const reqEmpresaCredenciais = {
	listId: async function (param) {
		return apiServer
			.get("portal/v1/empresa-credenciais", {
				params: {
					param,
				},
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				if (response.data && response.data.api_key) {
					response.data.api_key = decryptApiKey(response.data.api_key);
				}
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
};

export default reqEmpresaCredenciais;
